import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Doughnut } from 'react-chartjs-2';
import moment from 'moment';
import { Grid } from './../../../../themes/default';
import { Legend } from './../../../../components/includes/ui';
import { CardDefault } from './../../../../components/includes/card';
import { Dropdown } from './../../../../components/includes/dropdown';
import { SnackbarStatic } from './../../../../components/includes/snackbar';
import { AutogestionService } from './../../../../services';
import { getPercentaje } from './../../../../utilities/utils';
import ThemeCustom from './../../../../themes/custom';

class AutogestionReport extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      report: null,
      dates: null,
      loading: false,
      error: false
    };
  }

  componentDidMount(){
    this._Find();
  }

  /*
  ** @Service
  ** @Description: Find log
  */

  _Find = () => {

    AutogestionService.reportFolderAttachments().then((response) => {

      this.setState({
        loading: true,
        report: response,
        dates: `${ moment().format('D MMMM, YYYY') }`
      });

      if(response.size > response.total){

        let notification  = {
          title: 'Autogestion: Espacio en disco superado',
          description: 'Por favor informar alerta al área de soporte para resolver el inconveniente.'
        };

        let notifications = {
          list: [...this.props.Notifications.list, notification]
        }

        this.props.Update(notifications);

      }

    }).catch((error) => {

      this.setState({ loading: true, error: true });

    });

  }

  /*
  ** @Event
  ** @Description: Redirect to list
  */

  handleRedirectToList = () => {

    this.props.history.push({
      pathname: `/autogestion`
    });

  }

  render() {

    const { loading, error, report, dates } = this.state;
    const legend = { display: false };

    const data = {
      options: {
        layout: {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }
        }
      },
    	labels: [
    		'Disponible',
    		'Utilizado'
    	],
    	datasets: [{
    		data: [
          this.state.report ? this.state.report.available : 0,
          this.state.report ? this.state.report.size : 0
        ],
    		backgroundColor: [
      		ThemeCustom.palette.success.main,
      		ThemeCustom.palette.warning.main
    		]
    	}]
    };

    return (
        loading && (
          <CardDefault
            title="Autogestion"
            subheader={ dates }
            action={
              <Dropdown items={
                  [
                    { label: 'Listado', event: () => { this.handleRedirectToList() } }
                  ]
                }
              />
            }
          >
            <Grid container spacing={8} justify="center" alignItems="center">

              { !error ? (
                <React.Fragment>
                  <Grid item lg={4} md={6} sm={12} xs={12}>
                    <Doughnut data={ data } legend={ legend }/>
                  </Grid>
                  <Grid item lg={8} md={6} sm={12} xs={12}>
                    { report && (
                      <React.Fragment>
                        <Legend
                          variant="success"
                          text={`${ getPercentaje(report.available, report.total) }% Disponible (${ report.available } ${ report.unit })`}
                        />
                        <Legend
                          variant="warning"
                          text={`${ getPercentaje(report.size, report.total) }% Utilizado (${ report.size } ${ report.unit })`}
                        />
                        <Legend
                          variant="info"
                          text={`${ getPercentaje(report.total, report.total) }% Total (${ report.total } ${ report.unit })`}
                          disableGutters
                        />
                      </React.Fragment>
                    )}
                  </Grid>
                </React.Fragment>
              ) : (
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SnackbarStatic
                    icon="info"
                    variant="warning"
                    message="Hubo un error interno, por favor intenta más tarde."
                    open={true}
                    fullWidth hideClose/>
                </Grid>
              )}

            </Grid>
          </CardDefault>
        )
      )
    }

}

const mapStateToProps = (state) => {
  return {
    Notifications: state.Notifications
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    Update: (data) => {
      dispatch({
        type: 'NOTIFICATIONS_UPDATE',
        data: data
      });
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AutogestionReport));
